import './studio-team.scss';
import { Slider } from '../slider/slider';

class StudioTeam {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-studio-team'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$studioteam = element;
        this.$toggle = this.$studioteam.querySelectorAll('[data-studio-team="toggle"]');
        this.mobile = false;
        this.slider = false;
        this.view = this.$studioteam.querySelector('[data-studio-team="toggle"]:checked').value;
    }

    initialize () {
        if (window.matchMedia('(max-width: 1023px)').matches) {
            this.mobile = true;
            this.switchState(this.view);
        } else {
            this.mobile = false;
            this.switchState('list');
        }
        this.setEvents();
    }

    initSlider (slider) {
        this.slider = new Slider(slider, {
            initAttr: this.settings.initAttr,
            autoHeight: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            calculateHeight: false,
            prevnext: false,
            speed: 750
        });
    }

    destroySlider () {
        if (typeof this.slider === 'object') {
            this.slider.destroy();
            this.slider = false;
        }
    }

    switchState (view) {
        switch (view) {
        case 'slider':
            this.initSlider(this.$studioteam);
            break;
        default:

            this.destroySlider();

            break;
        }
    }

    setEvents () {
        document.addEventListener('design_s', () => {
            this.mobile = true;
            this.switchState(this.view);
        });

        document.addEventListener('design_m', () => {
            this.mobile = true;
            this.switchState('list');
        });

        document.addEventListener('design_l', () => {
            this.mobile = false;
            this.switchState('list');
        });

        this.$toggle.forEach(button => {
            button.addEventListener('change', () => {
                this.view = button.value;

                if (this.mobile === true) {
                    this.switchState(this.view);
                }
            });
        });
    }
}

export { StudioTeam };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$studioTeam = $context.querySelectorAll('[data-studio-team="root"]');
        for (let i = 0; i < $$studioTeam.length; i++) {
            const $studioTeam = new StudioTeam($$studioTeam[i]);
            $studioTeam.initialize();
        }
    }
});
